
import { observer } from 'mobx-react';
import * as React from 'react'
import { IntlProvider } from "react-intl"
import { Language } from "./models/Enums";

export type IntlProviderWrapperProps = {
    languageSettings: { language: Language }
    children: React.ReactNode
}

export const IntlProviderWrapper = observer(({languageSettings, children} : IntlProviderWrapperProps) => {
    const locale: string = languageSettings?.language
    const localePrefix = (locale === 'English') ? 'en' : 'sv' //sätter default till svenska
    const messages = require(`./translations/${localePrefix}`).default

    return (
        <IntlProvider messages={messages} locale={localePrefix} key={localePrefix}>
            {React.Children.only(children)}
        </IntlProvider>
    );
})